(function(angular) {
    angular.module('bizPartEngage').controller('modules.speedquiz.list', speedquizListController);
    angular.module('bizPartEngage').controller('modules.speedquiz.play', speedquizPlayController)
    angular.module('bizPartEngage').controller('modules.speedquiz.highscore', speedquizHighscoreController)

	speedquizListController.$inject = ["$state", "$stateParams", "modules.speedquiz.service", "$filter", "bizEngageService"];
	speedquizPlayController.$inject = ["$stateParams", "bizUser", "$filter", "modules.speedquiz.service", "$scope", "$window", "$q", "bizEngageService"];
    speedquizHighscoreController.$inject = ["$stateParams", "modules.speedquiz.service"];

	function speedquizListController($state, $stateParams, speedquizService, $filter, bizEngageService) {
        var vm = this;
        vm.PluginInstanceId = ~~$stateParams.pluginInstanceId;
        vm.SpeedquizName = $stateParams.urlRewrite;//not actually used, just for show.
        vm.Speedquizes = [];

        vm.PlaySpeedquiz = PlaySpeedquiz;
        vm.GoToHighscore = GoToHighscore;

        function GoToHighscore(speedquiz) {
            $state.go('base.modules.speedquizhighscore', {pluginInstanceId: speedquiz.PluginInstanceId, name: speedquiz.Name});
        }

        function PlaySpeedquiz(speedquiz) {
            var state = 'base.modules.speedquizplay';
            if (vm.PluginInstanceId === speedquiz.PluginInstanceId) {
                state = 'base.modules.speedquizplayfromone';
            }
            $state.go(state, { id: speedquiz.UrlRewrite || speedquiz.Id, pluginInstanceId: speedquiz.PluginInstanceId });
        }

        function GetSpeedquizes() {
            speedquizService.GetSpeedquizInstancesForLoggedInUser().then(GetSpeedquizesSuccess);
            
            function GetSpeedquizesSuccess(response) {
                if (vm.PluginInstanceId) {
                    vm.Speedquizes = $filter('filter')(response.data, { PluginInstanceId: vm.PluginInstanceId });                    
                } else {
                    vm.Speedquizes = response.data;
				}

				if (vm.Speedquizes && vm.Speedquizes.length === 1 && vm.PluginInstanceId > 0) {
					vm.QuizItem = {
						Id: vm.Speedquizes[0].Id,
						PluginInstanceId: vm.PluginInstanceId,
						EngageObjectType: 5
					}
				}
            }
        }

        function Init() {
            GetSpeedquizes();
			speedquizService.HasGuiOverrides();//caches result in session storage, which will decrease delay in start when the quiz actually launches

			bizEngageService.GetMiniJourneySetting('Speedquiz').then(function (response) {
				vm.MiniJourneySettings = response;
			});   
        }

        vm.$onInit = Init;
    }

	function speedquizPlayController($stateParams, user, $filter, speedquizService, $scope, $window, $q, bizEngageService) {
        var vm = this;
        if (~~$stateParams.id > 0) {
            vm.SpeedquizId = ~~$stateParams.id;
        } else {
            vm.SpeedquizUrlRewrite = $stateParams.id
        }
        vm.FromOneQuiz = $stateParams.fromOneQuiz === true;
        vm.SpeedquizId = ~~$stateParams.id > 0 ? ~~$stateParams.id : 0;
        vm.pluginInstanceId = ~~$stateParams.pluginInstanceId;
        vm.userSession = user.getLoggedInUser().Token;        
        vm.hasCustomerGuiOverrides = false;

        vm.ShowGame = false;
        vm.IsLoading = true;

        vm.GetIframeUrl = GetIframeUrl;

        const postMessageReceived = (event) => {
            console.log("message received", event);            
            if (event.origin === $window.location.origin && event.data === 'ISLOADED') {
                vm.IsLoading = false;
                $scope.$digest();
            }            
        };

        function GetIframeUrl() {            
            var url = "/Speedquiz/index.html?quizId=" + vm.SpeedquizId + "&siteRootPath=" + siteRootPath + "&UserSession=" + vm.userSession + "&lang=" + cultureCode.substring(0, 2);            
            if (vm.hasCustomerGuiOverrides) {
                url = url + '&customer=' + portalAlias;
            }            

            return $filter('siteroot')(url);
        }
        
        
        function Init() {

            $window.addEventListener('message', postMessageReceived);

            var pList = [speedquizService.HasGuiOverrides()];
            if (vm.SpeedquizUrlRewrite) {                
                pList.push(speedquizService.GetSpeedquizIdByUrlRewrite(vm.SpeedquizUrlRewrite));
            }

            $q.all(pList).then(Callback);

            function Callback(result) {                
                vm.hasCustomerGuiOverrides = result[0];
                if (vm.SpeedquizUrlRewrite) {
                    vm.SpeedquizId = ~~result[1].data;                    
                }
				vm.ShowGame = true;

				vm.QuizItem = {
					Id: vm.SpeedquizId,
					PluginInstanceId: vm.pluginInstanceId,
					EngageObjectType: 5
				}
			}

			bizEngageService.GetMiniJourneySetting('Speedquiz').then(function (response) {
				vm.MiniJourneySettings = response;
			});   
            
            //speedquizService.HasGuiOverrides().then(function (response) {                
            //    vm.hasCustomerGuiOverrides = response;                
            //    vm.ShowGame = true;                
            //});
        }

        vm.$onInit = Init;

        $scope.$on("$destroy", () => {
            $window.postMessage('QUIZCLEANUP', $window.location.origin);
            $window.removeEventListener('message', postMessageReceived);
        });
    }

    function speedquizHighscoreController($stateParams, speedquizService) {
        var vm = this;
        vm.pluginInstanceId = ~~$stateParams.pluginInstanceId;
        vm.speedquizName = $stateParams.name;
        vm.Highscore = [];

        vm.GetHighscore = GetHighscore;
        vm.GoBack = GoBack;

        function GoBack() {
            window.history.back();
        }

        function GetHighscore() {
            speedquizService.GetHighscore(vm.pluginInstanceId, 10).then(GetHighscoreSuccess);

            function GetHighscoreSuccess(response) {
                vm.Highscore = response.data.ScoreItems;
            }
        }

                
        function Init() {
            vm.GetHighscore();
        }

        vm.$onInit = Init;
    }
})(window.angular);
